import React, { memo, useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createSelector } from 'reselect';
import styles from './ZtShowApp.module.less';

import { CONTEXT } from '../../config';
import { logging, logPostInfo } from '../../actions/log';
import SoftCardZtShow from '../../components/SoftCardZtShow/SoftCardZtShow';
import { sortSoftsByLocalSoftInit, getUrlByTargetContent } from '../../utils/utils';
import { useInView } from 'react-intersection-observer';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectLocalSoftsInit = createSelector(
  state => state.native,
  native => native.installedSoftInit,
);

export default memo(({ data, logInfo }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const logInfoData = useSelector(selectLogInfo);
  const localSoftsInit = useSelector(selectLocalSoftsInit);

  const [showData, setShowData] = useState(null);
  const [showSofts, setShowSofts] = useState([]);

  const pageSize = 5;
  const LOG_ACTION_SOURCE = {
    c_hanlde: `${logInfo.tag}_Group_ZtSoft`,
    source: `${logInfo.tag}_Group_ZtSoft`,
  };
  const [ref, inView] = useInView({
    threshold: 1,
  });

  useEffect(() => {
    if (inView && logInfo && logInfo.changView) {
      logInfo.changView({
        pageCardId: data && data.dataList && data.dataList[0] && data.dataList[0].pageCardContentId,
        pageCardTitle: data && data.title,
      });
    }
  }, [inView]);

  // 筛洗数据，去除运营配置数据错误情况
  useEffect(() => {
    if (
      data &&
      data.dataList &&
      data.dataList.length > 0 &&
      data.dataList[0] &&
      data.dataList[0].ztId
    ) {
      const showSoftArr = sortSoftsByLocalSoftInit(data.dataList[0].apps || [], localSoftsInit);
      setShowSofts(showSoftArr.slice(0, pageSize));
      setShowData(data.dataList[0]);
    }
  }, [dispatch, localSoftsInit]);

  const handleZtCard = useCallback(() => {
    dispatch(
      logging({
        category: 'C',
        action: LOG_ACTION_SOURCE.c_hanlde,
        label: '',
        param2: {
          source: `${LOG_ACTION_SOURCE.source}`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          ztId: showData.ztId,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source_p: `${LOG_ACTION_SOURCE.source}`,
        source_pp: logInfoData.source_p,
      }),
    );
    if (showData.targetContent && showData.targetType) {
      if (
        showData.targetType === '1' ||
        showData.targetType === '3' ||
        showData.targetType === '11'
      ) {
        let url = `${CONTEXT}/recommend`;
        if (showData.targetType && showData.targetContent) {
          url = getUrlByTargetContent(showData);
        }
        history.push(url);
      }
    } else if (showData.ztId) {
      history.push(`${CONTEXT}/special?ztId=${showData.ztId}`);
    }
  }, [dispatch, showData]);

  return (
    <>
      {showData && showData.ztId && showData.apps && showData.apps.length > 0 ? (
        <div className={styles.card} ref={ref}>
          <div className={styles.card_header}>
            <div className={styles.card_header_title}>{data.title}</div>
          </div>
          <img
            className={styles.card_img}
            src={showData.contentImg}
            onClick={() => {
              handleZtCard();
            }}
          />
          {showData.buttonTitle && (
            <div
              className={styles.card_btn}
              onClick={() => {
                handleZtCard();
              }}
            >
              {showData.buttonTitle}
            </div>
          )}
          <div className={styles.card_soft}>
            {showSofts.map((item, index) => (
              <SoftCardZtShow
                soft={item}
                ztInfo={showData}
                key={index}
                logInfo={{
                  ...logInfo,
                  source: `${LOG_ACTION_SOURCE.source}||${showData.pageCardContentId}`,
                }}
              />
            ))}
            <div />
          </div>
        </div>
      ) : (
        ''
      )}
    </>
  );
});
